import { render, staticRenderFns } from "./TestTables.vue?vue&type=template&id=66812f12&"
import script from "./TestTables.vue?vue&type=script&lang=js&"
export * from "./TestTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\yuichi\\git\\open_coupon\\public\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66812f12')) {
      api.createRecord('66812f12', component.options)
    } else {
      api.reload('66812f12', component.options)
    }
    module.hot.accept("./TestTables.vue?vue&type=template&id=66812f12&", function () {
      api.rerender('66812f12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tables/TestTables.vue"
export default component.exports